import * as React from "react";

interface SidebarLinkGroupProps {
  children: (handleClick: () => void, open: boolean) => React.ReactNode;
  activeCondition: boolean;
}

const SidebarLinkGroup = ({ children, activeCondition }: SidebarLinkGroupProps) => {
  const [open, setOpen] = React.useState(activeCondition);

  const handleClick = () => {
    setOpen(!open);
  };

  return <li>{children(handleClick, open)}</li>;
};

export default SidebarLinkGroup;
